import * as Sentry from "@sentry/react"
import { SENTRY_DSN } from "./env"

export function initSentry() {
	Sentry.init({
		dsn: SENTRY_DSN,
		environment: import.meta.env.MODE,
		ignoreErrors: [
			"User denied",
			"User rejected",
			"Failed to fetch",
			"NetworkError",
			"ResizeObserver loop",
			"Load failed",
			"Aborted",
			"AbortError",
			"OAuth account is suspended",
			"Origin not allowed",
			"Connection lost while action was in flight",
			"Failed to load page. Please reload.",
			"Cannot redefine property: ethereum",
			"Cannot set property ethereum",
		],
		denyUrls: [/chrome-extension:\/\//, /moz-extension:\/\//],
		tracesSampleRate: 0.1,
	})
}

export function setSentryUser(id: string, handle?: string) {
	Sentry.setUser({ id, username: handle })
}

export function clearSentryUser() {
	Sentry.setUser(null)
}

export function captureSentryMessage(
	message: string,
	context?: Parameters<typeof Sentry.captureMessage>[1],
) {
	Sentry.captureMessage(message, context)
}

export function captureSentryException(
	error: unknown,
	context?: Parameters<typeof Sentry.captureException>[1],
) {
	Sentry.captureException(error, context)
}
